import { Input } from '@components/common';
import { Search } from 'lucide-react';
import React from 'react';

interface ClientsSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const ClientsSearchBar: React.FC<ClientsSearchBarProps> = ({
  value,
  onChange,
}) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-4">
    <div className="relative max-w-md">
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        size={16}
      />
      <Input
        value={value}
        onChange={(val) => onChange(String(val))}
        placeholder="Search by client name, email, contact or TIN"
        className="pl-10"
      />
    </div>
  </div>
);
